import { render, staticRenderFns } from "./loan-summary-by-customer.vue?vue&type=template&id=d1b007f2&"
import script from "./loan-summary-by-customer.vue?vue&type=script&lang=js&"
export * from "./loan-summary-by-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports